import React from 'react';

// This is a public URL
export const defaultSettings = {
	mode: process.env.REACT_APP_BUILD_MODE,
	fixedModes: [
		'hosted', 'editor', 'sample'
	],
	// Default logo should always be present
	// TODO: Disbale this in env
	// logo: process.env.REACT_APP_BUILD_MODE === 'sample' ? '/img/ta-logo-plain.png' : '/img/ta-header.png',
	// Default locale should always be present
	locale: {
		default: 'en',
		// These are locale overrides, and are optional
		// Currently specific to the branch: vox_public_channel
		// TODO: Once channel settings are available, build this as a channel
		en: process.env.REACT_APP_BUILD_MODE === 'sample' ? {
			'start-main': 'Share your voice with anyone, anywhere',
			'start-sub': `​- No registration -
			%break%
			1. Record your message or audio
			%break%
			2. Send to anyone or get a link to share anywhere
			%break%
			It's instant - It's free
			`
		} : {

		}
	},
	// Common settings, not page-specific, required, but can be empty
	common: process.env.REACT_APP_BUILD_MODE === 'hosted' ? {
		primaryColor: 'primary_color',
		header: {
			stretch: process.env.REACT_APP_BUILD_MODE !== 'sample',
			scale: process.env.REACT_APP_BUILD_MODE === 'sample' ? 0.3 : 1,
			attach: process.env.REACT_APP_BUILD_MODE === 'sample' ? 'left' : 'center',
		},
		fontFamily: 'font_family',
		fontColor: 'font_color',
		buttonColor: 'button_color',
		waveformColor: 'waveform_color',
		containerBorderColor: 'container_border_color',
		containerShadowColor: 'container_shadow_color',
		requiredShadow: 'required_shadow',
		hideGreyBar: 'hide_grey_bar',
		headerGradientLeftColor: 'header_gradient_left_color',
		headerGradientRightColor: 'header_gradient_right_color',
		isContactSkip: 'is_contact_skip',
		recordingTimeLimit: parseInt('record_max_length'), // in seconds
		recordMaxLength: parseInt('record_max_length'), // in seconds
		gradientColor1: '#caf4a3',
		gradientColor2: '#f44348',
		voxPosition: 'vox_position',
		voxButtonShape: 'vox_button_shape',
		voxButtonText: 'vox_button_text',
		dimBackground: 'dim_background',
		showHoverText: 'show_hover_text',
		voxButtonPosition: 'vox_button_position',
		logoUrl: 'logo_url',
		privacyLink: 'privacy_link',
		anchorText: 'anchor_text',
		desiredWebLink: 'desired_web_link',
		isPublicHosted: 'is_public_hosted',
		nameRequired: 'name_required',
		emailRequired: 'email_required',
		phoneRequired: 'phone_required',
		privacyLinkRequired: 'privacy_link_required',
		headerLogoRequired: 'header_logo_required',
		countryCode: 'country_code',
		nameEnabled: "name_enabled",
		emailEnabled: "email_enabled",
		phoneEnabled: "phone_enabled",
	}:{
		primaryColor: '#2E394F',
		header: {
			stretch: process.env.REACT_APP_BUILD_MODE !== 'sample',
			scale: process.env.REACT_APP_BUILD_MODE === 'sample' ? 0.3 : 1,
			attach: process.env.REACT_APP_BUILD_MODE === 'sample' ? 'left' : 'center',
		},
		fontFamily: 'Titillium Web',
		isContactSkip: false,
		fontColor: '',
		buttonColor: '#FF9D05',
		waveformColor: '#FFD815',
		containerBorderColor: '#caf4a3',
		containerShadowColor: 0,
		requiredShadow: true,
		hideGreyBar: false,
		headerGradientLeftColor: '#FFD815',
		headerGradientRightColor: '#FF9D05',
		recordingTimeLimit: 900, // in seconds
		recordMaxLength: 900, // in seconds
		gradientColor1: '#caf4a3',
		gradientColor2: '#f44348',
		logoUrl: '',
		voxPosition: 'defaultPosition',
		voxButtonShape: 'rectangle',
		voxButtonPosition: 'right',
		voxButtonText: "Send us a voice message",
		showHoverText: "",
		dimBackground: "",
		privacyLink: 'https://www.telbee.io/privacy/',
		anchorText: 'Visit our website',
		desiredWebLink: '',
		isPublicHosted: false,
		nameRequired: false,
		emailRequired: false,
		phoneRequired: false,
		privacyLinkRequired: "true",
		headerLogoRequired: true,
		countryCode: "us",
		nameEnabled: "true",
		emailEnabled: "true",
		phoneEnabled: "true",
	},
	// Page specific tweaks, required, but can be empty
	pages: {
		triggerIds: ['send_us_a_vox']
	},
	// Recorder settings for the Opus recorder
	// More options here: https://gitlab.com/telbee/vox-recorder-plugin#general-config-options
	recorder: {
		contentType: "audio/mpeg",
		monitorGain: parseInt(0, 10),
		recordingGain: parseInt(1, 10),
		numberOfChannels: parseInt(1, 10),
		encoderSampleRate: 16000,
		originalSampleRateOverride: 16000,
		encoderPath: `${process.env.PUBLIC_URL}/thirdparty/encoderWorker.min.js`
	}
};

let waveformHeight;
if (window.innerHeight > window.innerWidth) {
	waveformHeight = 380; //mobile
} else {
	waveformHeight = 120; //desktop
}

export const setLinearGradient = settings => {
	const linearGradient = document.createElement('canvas').getContext('2d').createLinearGradient(0, 0, 0, 200);
	linearGradient.addColorStop(0.3, settings.common.waveformColor);
	linearGradient.addColorStop(0.6, settings.common.buttonColor);

	settings.common.linearGradient = linearGradient;

	return settings;
}

const Settings = React.createContext(defaultSettings);

export default Settings;
